import { useEffect, useState } from "react";

type NavItem = {
    id: string;
};

const HEADER_OFFSET = 96;
const ACTIVATION_OFFSET = 48;

export function useActiveSection(items: readonly NavItem[], initialSection = "tracks") {
    const [activeSection, setActiveSection] = useState(initialSection);

    useEffect(() => {
        let frame = 0;

        const updateActiveSection = () => {
            const focusLine = HEADER_OFFSET + ACTIVATION_OFFSET;
            const sections = items
                .map((item) => document.getElementById(item.id))
                .filter((node): node is HTMLElement => node instanceof HTMLElement);

            if (sections.length === 0) return;

            const containingSection = sections.find((section) => {
                const rect = section.getBoundingClientRect();
                return rect.top <= focusLine && rect.bottom >= focusLine;
            });

            if (containingSection) {
                setActiveSection(containingSection.id);
                return;
            }

            const passedSections = sections.filter(
                (section) => section.getBoundingClientRect().top <= focusLine
            );

            if (passedSections.length > 0) {
                setActiveSection(passedSections[passedSections.length - 1].id);
                return;
            }

            setActiveSection(sections[0].id);
        };

        const requestUpdate = () => {
            if (frame) return;

            frame = window.requestAnimationFrame(() => {
                frame = 0;
                updateActiveSection();
            });
        };

        requestUpdate();

        window.addEventListener("scroll", requestUpdate, { passive: true });
        window.addEventListener("resize", requestUpdate);

        return () => {
            if (frame) window.cancelAnimationFrame(frame);
            window.removeEventListener("scroll", requestUpdate);
            window.removeEventListener("resize", requestUpdate);
        };
    }, [items]);

    return activeSection;
}
